// 匈牙利语
import huLocale from 'element-ui/lib/locale/lang/hu'


const hu = {
  // ============= 登录 start ============
  "验证码": "Ellenőrző kód",
  "登录": "Belépés",
  "请输入验证码": "Kérjük, adja meg az ellenőrző kódot",
  "验证码不正确!": "Helytelen ellenőrző kód!",
  "请输入账号": "Kérjük, adja meg a fiókját",
  "请输入密码": "Kérjük, adja meg a jelszavát",
  "访问地址有误，请在shop后台核实": "A hozzáférési cím helytelen, kérjük, ellenőrizze az üzlet backendjében",
  // ============= 登录 end ============

  // ============= Layout start ============
  "全屏模式": "Teljes képernyő mód",
  "首页": "Kezdőlap",
  "此操作将退出登录, 是否继续?": "Ez a művelet kijelentkeztet, folytatni szeretné?",
  "已取消退出": "Kijelentkezés megszakadt",
  "您有一个新订单": "Önnek van egy új rendelése",
  "无法获取当前门店信息，请重新登录": "Nem sikerült megszerezni az aktuális üzleti információkat, kérjük, jelentkezzen be újra",
  "收银台": "Pénztár",
  "收银": "Fizetés",
  "桌台": "Asztal",
  "订单": "Rendelés",
  // ============= Layout end ============

  // ============= 首页 start ============
  "查询会员": "Tag keresése",
  "商品改价": "ár módosítás",
  "商品删行": "Törölje a tételt",
  "整单取消": "Rendelés törlése",
  "挂单": "Rendelés elhelyezése",
  "折扣": "Kedvezmény",
  "抹零": "Kerekítés",
  "请输入内容": "Kérjük, adja meg a tartalmat",
  "收银员": "Pénztáros",
  "店内就餐": "Helyben fogyasztás",
  "打包带走": "Elvitel",
  "商品名称": "Termék neve",
  "商品价格": "Termék ára",
  "商品数量": "Termék mennyisége",
  "应收": "Teljes fizetendő",
  "包装费": "Csomagolási díj",
  "优惠": "Kedvezmény",
  "数量": "Mennyiség",
  "件": "Darab",
  "实收": "Befizetett összeg",
  "收款": "Befizetés",
  "请选择商品": "Kérjük, válasszon termékeket",
  "确定要删除": "Biztosan törölni szeretné",
  "提示": "Tipp",
  "确定": "Megerősít",
  "取消": "Mégse",
  "请先将购物车内的商品挂单或结账后再取单": "Kérjük, tartsa vagy fizessen ki a termékeket a bevásárlókosárban, mielőtt átvenné a rendelést",
  "确定要整单取消吗?": "Biztosan törölni szeretné a rendelést?",
  "请输入会员手机号查询会员，输入完毕后点击确认": "Kérjük, adja meg a tagsági telefonszámot a kereséshez, majd kattintson a megerősítésre",
  "请输入会员手机号": "Kérjük, adja meg a tagsági telefonszámot",
  "会员昵称": "Tag becenév",
  "余额总计": "Teljes egyenleg",
  "退出": "Kilépés",
  "该用户不存在": "Ez a felhasználó nem létezik",
  "折扣抹零": "Kedvezmény / Kerekítés",
  "当前价格": "Jelenlegi ár",
  "改价": "Ár megváltoztatása",
  "实付价格": "Tényleges ár",
  "请输入实付价格": "Kérjük, adja meg a tényleges árat",
  "优惠折扣": "Kedvezmény mértéke",
  "请输入优惠折扣": "Kérjük, adja meg a kedvezmény mértékét",
  "抹分": "Kerekítés a legközelebbi tizedig",
  "抹角": "Kerekítés a legközelebbi dollárba",
  "四舍五入到角": "Kerekítés a legközelebbi tizedig",
  "四舍五入到元": "Kerekítés a legközelebbi dollárba",
  "确 定": "Megerősít",
  "价格不能为空": "Az ár nem lehet üres",
  "折扣不能为空": "A kedvezmény nem lehet üres",
  "修改价格": "Ár módosítás",
  "本次售价": "Jelenlegi eladási ár",
  "请输入本次售价": "Kérjük, adja meg a jelenlegi eladási árat",
  "清空": "Törlés",
  "确认": "Megerősít",
  "商品详情": "Termék részletek",
  "单位": "Egység",
  "规格": "Specifikációk",
  "加料": "Extra hozzávalók",
  "取 消": "Mégse",
  "现金收款": "Készpénzes fizetés",
  "余额收款": "Egyenleg fizetés",
  "其他方式": "Egyéb módszerek",
  "应收金额": "Teljes összeg",
  "用户通过店内扫码等方式进行支付，确认用户支付成功后，点击确认付款即可完成付款操作。": "A vásárlók áruházi QR kód és más módszerek segítségével fizethetnek. A sikeres fizetés megerősítése után kattintson a 'Fizetés megerősítése' gombra a tranzakció befejezéséhez.",
  "微信支付": "WeChat Fizetés",
  "支付宝支付": "Alipay Fizetés",
  "pos刷卡": "POS Kártyás fizetés",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Kérjük, adja meg a tagsági azonosítót a tag kereséséhez, majd kattintson a megerősítésre",
  "请输入会员ID": "Kérjük, adja meg a tagsági azonosítót",
  "登录会员仅作为积分累计，无法享受其他优惠。": "A bejelentkezett tagok csak pontokat gyűjtenek, és nem jogosultak más kedvezményekre.",
  "取消收款": "Fizetés törlése",
  "订单总价": "Rendelés teljes ára",
  "挂单时间": "Rendelés tartási ideje",
  "删除": "Törlés",
  "取单": "Rendelés átvétele",
  "多语言小票打印": "Többnyelvű blokknyomtatás",
  "打印语言": "Nyomtatási nyelv",
  "中文": "Kínai",
  "英语": "Angol",
  "德语": "Német",
  "法语": "Francia",
  "西班牙语": "Spanyol",
  "意大利语": "Olasz",
  "克罗地亚": "Horvát",
  "斯洛文尼亚": "Szlovén",
  "匈牙利语": "Magyar",
  "塞尔维亚语": "Szerb",
  // ============= 首页 end   ============

  // ============= 桌台 start ============
  "未开台": "Nem nyitott",
  "已开台": "Asztal megnyitva",
  "就餐中": "Étkezés",
  "刷新": "Frissítés",
  "整单清空": "Teljes rendelés törlése",
  "转台": "Asztal áthelyezése",
  "打印预结单": "Előzetes számla nyomtatása",
  "催菜": "Rendelés sürgetése",
  "人数": "Vendégek száma",
  "订单来源": "Rendelés forrása",
  "请点击左侧桌号台": "Kattintson az asztal számára a baloldalon",
  "点选已开台桌台，可以在此查看点餐信息。": "Válassza ki az asztalt a megrendelési információk megtekintéséhez itt.",
  "服务费": "Szolgáltatási díj",
  "税费": "Adó",
  "协助点餐": "Segítés rendelésben",
  "协助加餐": "Segítés étel hozzáadásában",
  "结账": "Számla fizetése",
  "完成": "Befejez",
  "价格": "Ár",
  "请选择": "Kérjük válasszon",
  "确定要打印小票吗?": "Biztosan nyomtatni szeretné a blokkot?",
  "确定要关闭桌台并取消订单吗?": "Biztosan le szeretné zárni az asztalt és törölje a rendelést?",
  "请选择桌号": "Kérjük válasszon asztalszámot",
  "就餐人数": "Vendégek száma",
  "下单": "Rendelés leadása",
  "返回": "Vissza",
  "确定要商品删行吗?": "Biztosan törölni szeretné a tételt?",
  "请选择就餐人数": "Kérjük válassza ki a vendégek számát",
  // ============= 桌台 end ============

  // ============= 订单 start ============
  "下单时间": "Rendelés ideje",
  "起始时间": "Kezdési idő",
  "店内订单": "Üzleti rendelés",
  "自提订单": "Átvételi rendelés",
  "外卖订单": "Házhozszállítás rendelés",
  "名称": "Név",
  "支付时间": "Fizetés ideje",
  "消费方式": "Fizetési mód",
  "状态": "Állapot",
  "单价": "Egységár",
  "金额": "Összeg",
  "税率": "Adókulcs",
  "税费金额": "Adóösszeg",
  "邮箱地址": "Email cím",
  "今天": "Ma",
  "昨天": "Tegnap",
  "一周": "Egy hét",
  "搜索": "Keresés",
  "待完成": "Befejezetlen",
  "已完成": "Befejezett",
  "已取消": "Törölt",
  "全部": "Összes",
  "顾客信息": "Vevői információk",
  "用户昵称": "Felhasználói becenév",
  "手机号": "Telefonszám",
  "收货地址": "Szállítási cím",
  "取单号": "Rendelés átvétel szám",
  "就餐方式": "Étkezés módja",
  "订单号": "Rendelésszám",
  "订单金额": "Rendelés összege",
  "订单优惠": "Rendelés kedvezmény",
  "实付金额": "Ténylegesen fizetett összeg",
  "支付方式": "Fizetési mód",
  "备注信息": "Megjegyzések",
  "期望配送时间": "Várható szállítási idő",
  "取餐时间": "Átvevési idő",
  "配送费": "Szállítási díj",
  "退款金额": "Visszatérítés összege",
  "准备中": "Előkészületben",
  "出餐中": "Főzés",
  "待取餐": "Várakozás az átvételre",
  "订单信息": "Rendelés információ",
  "税费详情": "Adó részletek",
  "取消订单": "Rendelés törlése",
  "打印小票": "Blokk nyomtatása",
  "出餐": "Étel kiszolgálás",
  "确认送达": "Szállítás megerősítése",
  "退款": "Visszatérítés",
  "已退款": "Visszafizetett",
  "请输入订单号": "Kérem adja meg a rendelésszámot",
  "至": "-",
  "开始日期": "Kezdési dátum",
  "结束日期": "Befejezési dátum",
  "发送账单": "Számla küldése",
  "请输入邮箱地址": "Kérjük, adja meg az e-mail címét",
  "确定要催菜吗?": "Biztosan sürgetni szeretné a rendelést?",
  "确定要完成订单吗?": "Biztosan befejezni szeretné a rendelést?",
  "确定要出餐吗?": "Biztosan kiszolgálni szeretné az ételeket?",
  "确定要发送账单吗?": "Biztosan elküldi a számlát?",
  "邮箱不能为空": "Az e-mail nem lehet üres",
  "确定要取消订单吗?": "Biztosan törölni szeretné a rendelést?",
  "是否确认此操作?": "Biztosan megerősíti ezt a műveletet?",
  "上传文件只能是excel格式!": "A feltöltött fájl csak Excel formátumban lehet!",
  "上传文件大小不能超过 10MB!": "A feltöltött fájl mérete nem lehet nagyobb 10MB-nál!",
  "正在处理,请等待": "Feldolgozás folyamatban, kérjük várjon",
  "本次处理失败": "A feldolgozás sikertelen volt",
  "总金额": "Teljes összeg",
  "可退款金额": "Visszatérítendő összeg",
  "请输入退款金额": "Kérjük, adja meg a visszatérítendő összeget",
  "超出可退款金额": "Túllép a visszatérítendő összegen",
  "404错误页面": "404-es Hibaoldal",
  "合计": "Összesen",
  "份": "Rész",
  "余额支付": "Egyenleg Fizetés",
  "线下支付(现金支付)": "Offline Fizetés (Készpénzfizetés)",
  "线下支付(微信支付)": "Offline Fizetés (Saját WeChat Fizetés)",
  "线下支付(支付宝支付)": "Offline Fizetés (Saját Alipay Fizetés)",
  "线下支付(POS刷卡支付)": "Offline Fizetés (POS Kártyafizetés)",
  "进行中": "Folyamatban",
  "待付款": "Fizetés Függőben",
  "待配送": "Szállításra Vár",
  "配送中": "Szállítás Alatt",
  "待接单": "Elfogadásra Vár",
  "待取货": "Áruátvételre Vár",
  "已配送": "Kiszállítva",
  "已收货": "Vétel Bekövetkezett",
  "待收货": "Vétel Várólistára Téve",
  "待取消": "Mégse Vár",
  "会员": "Tag",
  "商家": "Kereskedő",
  "供应商": "Beszállító",
  "分销": "Forgalmazás",
  "通知": "Értesítés",
  "已付款": "Fizetve",
  "用户下单": "Felhasználó Rendel",
  "收银台下单": "Pénztári Rendelés",
  "扫码下单": "Rendelés Kód Beolvasásával",
  "团购下单": "Csoportos Vásárlás Rendelése",
  "商城订单": "Áruházi Rendelés",
  "积分商城订单": "Pontokkal Rendelhető Áruházi Rendelés",
  "余额充值订单": "Egyenlegfeltöltési Rendelés",
  "购卡订单": "Kártyavásárlási Rendelés",
  "券包订单": "Kuponcsomag Rendelés",
  "配送员押金订单": "Szállítói Letét Rendelés",
  "团购订单": "Csoportos Vásárlási Rendelés",
  "下单减库存": "Raktárkészlet Csökkentése Rendeléskor",
  "付款减库存": "Raktárkészlet Csökkentése Fizetéskor",
  "商家配送": "Kereskedői Szállítás",
  "外卖配送": "Házhozszállítás",
  "到店自提": "Személyes Átvétel",
  "快递配送": "Expressz Szállítás",
  "个人中心": "Személyes Központ",
  ...huLocale
}


export default hu



// WEBPACK FOOTER //
// ./src/i18n/langs/hu.js